import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { postAccessLog } from '@/utils/requests/camp/requests_burying_point';
import { useRequest, useParams, useModel } from 'umi';
import { isMobileValue } from '@/pages/camp/util/indexUtil';

const EventTracking = () => {
  const history = useHistory();
  const { initialState } = useModel('@@initialState');

  // 获取接口
  const { run: accessPagesRequest } = useRequest(
    (parame) => {
      return postAccessLog(parame);
    },
    {
      manual: true,
      onSuccess: (res) => {},
    },
  );

  useEffect(() => {
    return history.listen((location) => {
      const parame = {
        url: process.env.EDU_URL + location.pathname,
        uid: null,
        sourceFrom: null,
        sourceUid: null,
        terminal: isMobileValue(),
      };
      if (initialState?.currentUser?.userId) {
        parame.uid = initialState?.uid;
      }
      // @ts-ignore
      let from = location.query?.from;
      if (from) {
        parame.sourceFrom = from;
      }
      // @ts-ignore
      let getUid = location.query?.uid;
      if (getUid) {
        parame.sourceUid = getUid;
      }
      setTimeout(function () {
        accessPagesRequest(parame);
      }, 1000);
    });
  }, [history]);

  return null;
};

export default EventTracking;
